import React from "react";
import Container from "./Container";
import Footer from "./Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Container />
      <Footer />
    </div>
  );
}
export default App;
